import { render, staticRenderFns } from "./AphtDetail.vue?vue&type=template&id=58bf0f06&scoped=true&"
import script from "./AphtDetail.vue?vue&type=script&lang=js&"
export * from "./AphtDetail.vue?vue&type=script&lang=js&"
import style0 from "./AphtDetail.vue?vue&type=style&index=0&id=58bf0f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf0f06",
  null
  
)

export default component.exports